import _extends from 'babel-runtime/helpers/extends';

export default {
  name: 'trafficConfigRadio',

  componentName: 'trafficConfigRadio',

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  computed: {
    innerConfig: function innerConfig() {
      var params = _extends({}, this.config.params);
      return _extends({}, this.config, {
        params: params
      });
    }
  }
};